import { UPDATE_IS_LCF_MANDATORY } from '../actions';

export const isLcfMandatory = (
  state = { isMandatory: false, isContact: false },
  action,
) => {
  switch (action.type) {
    case UPDATE_IS_LCF_MANDATORY: {
      return action.isLcfMandatory;
    }
    default:
      return state;
  }
};
